import {
  AgeCategory,
  Discoverability,
  EarliestStart,
  TalentJobExperience,
  HighestDegree,
  TalentJobInterest,
  JobInterestLevels,
  Language,
  LanguageLevel,
  LanguageLevelOld,
  LanguageOld,
  LocationsOfInterest,
  LocationsOfInterestOld,
  ManagedTeams,
  ManagedTeamsOld,
  None,
  NoticePeriod,
  Positions,
  PreviousRoles,
  PreviousWorkExperience,
  Salaries,
  SalesIndustries,
  SearchActivity,
  SeniorityLevel,
  SoldProducts,
  TalentProfileStatuses,
  TeamSize,
  WillingRemote,
  YearsOfExperience,
  YearsOfExperienceOld,
} from '~/lib/talentProfileEnums'

export default {
  highestDegree: {
    [HighestDegree.Msa]: 'MSA',
    [HighestDegree.Abitur]: 'Abitur',
    [HighestDegree.Ausbildung]: 'Abgeschloßene Ausbildung',
    [HighestDegree.Bachelor]: 'Bachelor',
    [HighestDegree.Master]: 'Master',
    [HighestDegree.Phd]: 'Dr. Titel',
    [None]: 'Keine',
  },
  seniorityLevel: {
    [SeniorityLevel.None]: 'Keine relevante Berufserfahrung',
    [SeniorityLevel.Junior]: '1-2 Jahre',
    [SeniorityLevel.MidLevel]: '3-5 Jahre',
    [SeniorityLevel.Senior]: '5+ Jahre',
    [SeniorityLevel.Principal]: '10+ Jahre',
    [None]: 'Keine',
  },
  seniorityLevelShort: {
    [SeniorityLevel.None]: '0',
    [SeniorityLevel.Junior]: '1-2',
    [SeniorityLevel.MidLevel]: '3-5',
    [SeniorityLevel.Senior]: '5+',
    [SeniorityLevel.Principal]: '10+',
  },
  teamSize: {
    [TeamSize.OneToThree]: '1 bis 3 Mitarbeiter',
    [TeamSize.ThreeToFive]: '3 bis 5 Mitarbeiter',
    [TeamSize.FiveToSeven]: '5 bis 7 Mitarbeiter',
    [TeamSize.SevenToTen]: '7 bis 10 Mitarbeiter',
    [TeamSize.TenToTwenty]: '10 bis 20 Mitarbeiter',
    [TeamSize.TwentyToFifty]: '20 bis 50 Mitarbeiter',
    [TeamSize.FiftyToHundred]: '50 bis 100 Mitarbeiter',
    [TeamSize.OverHundred]: 'Über 100 Mitarbeiter',
    [None]: 'Keine',
  },
  language: {
    [Language.German]: 'Deutsch',
    [Language.English]: 'Englisch',
    [Language.Turkish]: 'Türkisch',
    [Language.Russian]: 'Russisch',
    [Language.Arabic]: 'Arabisch',
    [Language.Spanish]: 'Spanisch',
    [Language.Italian]: 'Italienisch',
    [Language.French]: 'Französisch',
    [Language.Vietnamese]: 'Vietnamesisch',
    [Language.Hindi]: 'Hindi',
    [Language.Urdu]: 'Urdu',
    [Language.Persian]: 'Persisch',
    [Language.Other]: 'Andere',
    [LanguageOld.German]: 'Deutsch',
    [LanguageOld.English]: 'Englisch',
    [LanguageOld.Turkish]: 'Türkisch',
    [LanguageOld.Russian]: 'Russisch',
    [LanguageOld.Arabic]: 'Arabisch',
    [LanguageOld.Spanish]: 'Spanisch',
    [LanguageOld.Italian]: 'Italienisch',
    [LanguageOld.French]: 'Französisch',
    [LanguageOld.Other]: 'Andere',
  },
  languageLevel: {
    [LanguageLevel.Native]: 'C2',
    [LanguageLevelOld.C2]: 'C2',
    [LanguageLevel.Proficient]: 'C1',
    [LanguageLevelOld.C1]: 'C1',
    [LanguageLevel.Skilled]: 'B1/B2',
    [LanguageLevel.Beginner]: 'A1/A2',
    [LanguageLevel.None]: 'Keine',
  },
  languageLevelProfileWizard: {
    [LanguageLevel.Native]: 'C2',
    [LanguageLevelOld.C2]: 'C2',
    [LanguageLevel.Proficient]: 'C1',
    [LanguageLevelOld.C1]: 'C1',
    [LanguageLevel.Skilled]: 'B1/B2',
    [LanguageLevel.Beginner]: 'Ich kenne die Basics',
    [LanguageLevel.None]: 'Keine',
  },
  languageLevelDescription: {
    [LanguageLevel.Native]: 'Über 5 Jahre tagtäglicher Gebrauch',
    [LanguageLevel.Proficient]: 'Fühle mich dabei wohl komplette Verkaufsgespräche zu führen',
    [LanguageLevel.Skilled]: 'Kann gut mit meinem Team und einzelnen Kunden Kommunizieren',
  },
  searchActivity: {
    [SearchActivity.Active]: 'Ich suche aktiv nach einem neuen Job',
    [SearchActivity.OpenForOffers]: 'Ich bin offen für Jobangebote, suche aber nicht aktiv',
    [SearchActivity.Inactive]: 'Ich suche nicht',
  },
  discoverability: {
    [Discoverability.Yes]: 'Ja, ich möchte auf der HYRE Top-Talent-Hotlist stehen 🔥',
    [Discoverability.No]: 'Nein, ich möchte nicht, dass Recruiter mein anonymisiertes Profil sehen',
  },
  discoverabilityShort: {
    [Discoverability.Yes]: 'Aktiv',
    [Discoverability.No]: 'Deaktiviert',
  },
  noticePeriod: {
    [NoticePeriod.None]: 'Keine',
    [NoticePeriod.OneMonth]: '1 Monat',
    [NoticePeriod.TwoMonths]: '2 Monate',
    [NoticePeriod.ThreeMonths]: '3 Monate',
    [NoticePeriod.ThreeToSixMonths]: '3 - 6 Monate',
    [NoticePeriod.SixOrMoreMonths]: '>6 Monate',
  },
  earliestStart: {
    [EarliestStart.WithinTwoWeeks]: 'Innerhalb der nächsten 2 Wochen',
    [EarliestStart.WithinThreeMonths]: 'Innerhalb der nächsten 3 Monate',
    [EarliestStart.BetweenThreeAndSixMonths]: 'Nach mehr als 3 und weniger als 6 Monaten',
    [EarliestStart.SixOrMoreMonths]: 'Erst nach 6 oder mehr Monaten',
  },
  managedTeams: {
    [ManagedTeams.SalesReps]: 'Sales Development Representative Team',
    [ManagedTeams.AccountExecutives]: 'Account Executive Team',
    [ManagedTeams.AccountManagers]: 'Account Manager Team',
    [ManagedTeams.WholeDepartment]: 'Gesamte Abteilung',
    [ManagedTeams.Other]: 'Andere',
    [ManagedTeamsOld.SalesReps]: 'Sales Development Representative Team',
    [ManagedTeamsOld.AccountExecutives]: 'Account Executive Team',
    [ManagedTeamsOld.AccountManagers]: 'Account Manager Team',
    [ManagedTeamsOld.WholeDepartment]: 'Gesamte Abteilung',
  },
  locationsOfInterest: {
    [LocationsOfInterest.Berlin]: 'Berlin',
    [LocationsOfInterest.Bonn]: 'Bonn',
    [LocationsOfInterest.FrankfurtAmMain]: 'Frankfurt am Main',
    [LocationsOfInterest.Dusseldorf]: 'Düsseldorf',
    [LocationsOfInterest.Essen]: 'Essen',
    [LocationsOfInterest.Hamburg]: 'Hamburg',
    [LocationsOfInterest.Heidelberg]: 'Heidelberg',
    [LocationsOfInterest.Koeln]: 'Köln',
    [LocationsOfInterest.Leipzig]: 'Leipzig',
    [LocationsOfInterest.Muenchen]: 'München',
    [LocationsOfInterest.Stuttgart]: 'Stuttgart',
    [LocationsOfInterest.Hannover]: 'Hannover',
    [LocationsOfInterestOld.Remote]: 'Remote (100% im Homeoffice)',
    [LocationsOfInterestOld.Uberall]: 'Überall',
    Other: 'Andere',
    OTHER: 'Andere',
  },
  salesIndustries: {
    [SalesIndustries.Agriculture]: 'Agrarwirtschaft',
    [SalesIndustries.Automotive]: 'Automobilbranche',
    [SalesIndustries.Construction]: 'Baugewerbe',
    [SalesIndustries.Education]: 'Bildung',
    [SalesIndustries.Chemicals]: 'Chemie & Rohstoffe',
    [SalesIndustries.Electronics]: 'Elektronik (Hardware)',
    [SalesIndustries.Energy]: 'Energieerzeugung',
    [SalesIndustries.HeavyIndustry]: 'Schwerindustrie',
    [SalesIndustries.Manufacturing]: 'Fertigungsbranche',
    [SalesIndustries.Finance]: 'Finanzen & Versicherungen',
    [SalesIndustries.ConsumerGoods]: 'FMCG & Lebensmittel',
    [SalesIndustries.Leisure]: 'Freizeit & Kultur & Sport',
    [SalesIndustries.RealEstate]: 'Immobilienwirtschaft',
    [SalesIndustries.Logistics]: 'Logistik',
    [SalesIndustries.HumanResources]: 'Personalwesen',
    [SalesIndustries.Health]: 'Pharma & Gesundheit',
    [SalesIndustries.ProfessionalServices]: 'Professionelle Dienstleistungen',
    [SalesIndustries.Law]: 'Recht',
    [SalesIndustries.Media]: '(Social) Media & Marketing',
    [SalesIndustries.Software]: 'Software & Analytics',
    [SalesIndustries.Telecomms]: 'Telekommunikation',
    [SalesIndustries.Hospitality]: 'Tourismus & Gastronomie & Events',
    [SalesIndustries.PublicSector]: 'Öffentlicher Dienst',
    [SalesIndustries.Textiles]: 'Textilien',
  },
  salesProductTypes: {
    [SoldProducts.Saas]: 'Softwarelösungen (SaaS)',
    [SoldProducts.TransactionalDigitalGoods]: 'Transaktionale Digitalgüter',
    [SoldProducts.RetailDistribution]: 'Vertrieb im Einzelhandel',
    [SoldProducts.PersonellServices]: 'Personaldienstleistungen',
    [SoldProducts.PhysicalGoods]: 'Physische Güter',
    [SoldProducts.PersonalServices]: 'Persönliche Dienstleistungen (z.B Beratung)',
    [SoldProducts.MarketPlace]: 'Marktplatz',
    [SoldProducts.TelecommContracts]: 'Telekommunikationsverträge',
    [SoldProducts.PromotionOrFundraising]: 'Promotion/ Fundraising',
    [SoldProducts.SolarEnergy]: 'Solar/ Photovoltaik Produkte oder Dienstleistungen',
    [SoldProducts.Bildungsgutscheine]: 'Bildungsgutscheine/ (Weiter)-Bildungsprogramme',
    [SoldProducts.Insurance]: 'Versicherungen & Versicherungsdienstleistungen',
  },
  positions: {
    [Positions.SDR]: 'Sales Development Representative (SDR)',
    [Positions.CSM]: 'Customer Success Manager (CSM)',
    [Positions.BDR]: 'Business Development Representative (BDR)',
    [Positions.AccountExecutive]: 'Account Executive',
    [Positions.SalesManager]: 'Sales Manager',
    [Positions.AccountManager]: 'Account Manager',
    [Positions.SalesTeamLead]: 'Sales Team Lead',
    [Positions.Graduate]: 'Graduate',
    [Positions.Other]: 'Sonstiges',
    [PreviousRoles.WorkingStudent]: 'Sales Praktikant/ Werkstudent/ Einsteiger/ Promo-Job',
    [PreviousRoles.SalesManager]: 'Sales Manager',
    [PreviousRoles.Aussendienstler]: 'Klassischer Außendienstler',
    [PreviousRoles.SdrBdr]: 'SDR/BDR',
    [PreviousRoles.AccountExecutive]: 'Account Executive',
    [PreviousRoles.CustomerSuccess]: 'Customer Success',
    [PreviousRoles.AccountManager]: 'Account Manager',
    [PreviousRoles.TeamManager]: 'Team Manager',
  },
  jobInterestLevels: {
    [JobInterestLevels.None]: 'Gar nicht',
    [JobInterestLevels.Unwilling]: 'Ungern',
    [JobInterestLevels.Normal]: 'Weder gerne noch ungerne',
    [JobInterestLevels.Gladly]: 'Gerne',
    [JobInterestLevels.VeryGladly]: 'Sehr gerne',
  },
  salaries: {
    [Salaries.T30K]: '0k - 30k',
    [Salaries.F30T40]: '30K - 40K',
    [Salaries.F40T50]: '40K - 50K',
    [Salaries.F50T60]: '50K - 60K',
    [Salaries.F60T70]: '60K - 70K',
    [Salaries.F70T80]: '70K - 80K',
    [Salaries.F80T90]: '80K - 90K',
    [Salaries.F90T100]: '90K - 100K',
    [Salaries.F100T110]: '100K - 110K',
    [Salaries.F110T120]: '110K - 120K',
    [Salaries.OVER120]: 'Over 120K',
  },
  experiences: {
    [TalentJobExperience.ColdCalling]: 'Cold Calling',
    [TalentJobExperience.SaasClosing]: 'SaaS B2B Closing',
    [TalentJobExperience.Closing]: 'B2B closing',
    [TalentJobExperience.SaasAccountManagement]: 'SaaS B2B Account Management',
    [TalentJobExperience.NonSaasAccountManagement]: 'Non-SaaS B2B Account Management',
    [TalentJobExperience.AccountManagement]: 'B2B Account Management',
    [TalentJobExperience.Leadership]: 'Teamführung',
  },
  interestAreas: {
    [TalentJobInterest.ColdCalling]: 'Cold Calling',
    [TalentJobInterest.SaasClosing]: 'Saas B2B Closing',
    [TalentJobInterest.SaasClosing]: 'B2B Closing',
    [TalentJobInterest.SaasAccountManagement]: 'Non-SaaS B2B Account Management',
    [TalentJobInterest.NonSaasAccountManagement]: 'Non-SaaS B2B Account Management',
    [TalentJobInterest.Leadership]: 'Teamführung',
  },
  willingRemote: {
    [WillingRemote.Yes]: 'Remote verfügbar',
    [WillingRemote.No]: 'Nicht-remote verfügbar',
  },
  ageCategory: {
    [AgeCategory.F18T20]: '18-20',
    [AgeCategory.F20T22]: '20-22',
    [AgeCategory.F22T25]: '22-25',
    [AgeCategory.F25T30]: '25-30',
    [AgeCategory.F30T40]: '30-40',
    [AgeCategory.F40T50]: '40-50',
    [AgeCategory.OVER50]: '50+',
  },
  status: {
    [TalentProfileStatuses.Draft]: 'Draft',
    [TalentProfileStatuses.PendingApproval]: 'Pending Approval',
    [TalentProfileStatuses.Approved]: 'Approved',
    [TalentProfileStatuses.Rejected]: 'Rejected',
  },
  previousRoles: {
    [PreviousRoles.WorkingStudent]: {
      label: 'Sales Praktikant/ Werkstudent/ Einsteiger/ Promo-Job',
      description: 'Erste Sales-Erfahrungen außerhalb einer Vollzeit-Anstellung',
    },
    [PreviousRoles.SalesManager]: {
      label: 'Sales Manager',
      description: 'Mit Privatkunden und kleinen Unternehmen Verträge abgeschloßen',
    },
    [PreviousRoles.Aussendienstler]: {
      label: 'Klassischer Außendienstler',
      description: 'Kunden vor-ort besucht, um Deals abzuschließen',
    },
    [PreviousRoles.SdrBdr]: {
      label: 'SDR/BDR',
      description: 'Unternehmenskundenleads identifiziert und warm gemacht',
    },
    [PreviousRoles.AccountExecutive]: {
      label: 'Account Executive',
      description: 'Mit größeren Unternehmen Verträge abgeschloßen',
    },
    [PreviousRoles.CustomerSuccess]: {
      label: 'Customer Success',
      description: 'Unternehmenskunden durch konstante Unterstützung ans Produkt gebunden',
    },
    [PreviousRoles.AccountManager]: {
      label: 'Account Manager',
      description: 'Umsatzsteigerung bei bestehenden Unternehmenskunden durch aktive Betreuung',
    },
    [PreviousRoles.TeamManager]: {
      label: 'Team Manager',
      description: 'Sales-teams geleitet',
    },
  },
  yearsOfExperience: {
    [YearsOfExperience.None]: 'Keine',
    [YearsOfExperienceOld.TwoMonths]: '2 Monate',
    [YearsOfExperience.SixMonths]: '6 Monate',
    [YearsOfExperience.OneYear]: '1 Jahr',
    [YearsOfExperience.TwoYears]: '2 Jahre',
    [YearsOfExperience.ThreeYears]: '3 Jahre',
    [YearsOfExperienceOld.OneAndAHalfYears]: '1,5 Jahre',
    [YearsOfExperienceOld.ThreeToFourYears]: '3-4 Jahre',
    [YearsOfExperience.ThreeToFiveYears]: '3-5 Jahre',
    [YearsOfExperienceOld.FiveToSixYears]: '5-6 Jahre',
    [YearsOfExperience.OverFiveYears]: 'Über 5 Jahre',
    [YearsOfExperienceOld.SevenToNineYears]: '7-9 Jahre',
    [YearsOfExperienceOld.TenPlusYears]: '10+ Jahre',
  },
}
